import React, { useState } from 'react';
import cx from 'classnames';

import styles from './HomeProfileOptionsSection.module.scss';

const ROLE_BUTTONS = [
  {
    id: 1,
    btnContent: (
      <>
        I am recruiter / <br />
        staffing
      </>
    ),
  },
  {
    id: 2,
    btnContent: (
      <>
        I represent corporate <br />
        talent acquisition / hr
      </>
    ),
  },
  {
    id: 3,
    btnContent: (
      <>
        I am a job seeker / <br />
        potential candidate
      </>
    ),
  },
];

export default function HomeProfileOptionsSection() {
  const [activeButton, setActiveButton] = useState<number>();

  return (
    <div className={styles.profileOptionsSection}>
      <div className="sub-title">
        <div className="sub-title-holder">
          Please click on what best fits your profile
        </div>
      </div>
      <div className="container">
        <div className="btn-row">
          {ROLE_BUTTONS.map(({ id, btnContent }) => (
            <div className="btn-col" key={id}>
              <button
                disabled={!!activeButton}
                onClick={() => setActiveButton(id)}
                className={cx('btn size-lg', {
                  'primary-btn': activeButton !== id,
                  'outlined-btn': activeButton === id,
                })}
              >
                {activeButton === id ? (
                  <span className="icon icon-like" />
                ) : (
                  <span>{btnContent}</span>
                )}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
